import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import "../assets/css/navbar.css";
// import axios from "axios";
import { useEffect, useState } from "react";

const showConsole = true;

export function NavTopMainEn() {
    const [navMenuItem] = useState([]);
    useEffect(() => {
        // axios
        //     .get("https://aed.mju.ac.th/api/arch/nav/index.json")
        //     .then((res) => {
        //         setNavMenuItem(res.data);
        //         console.log(res.data);
        //     })
        //     .catch((error) => {
        //         console.error(`nav axios err: ${error}`);
        //     });
    }, []);

    return (
        <Navbar expand="lg" className="navBackgroundColor">
            <Container>
                <Navbar.Brand href="/" className="navBrand">
                    ARCH
                </Navbar.Brand>
                <Navbar.Toggle
                    aria-controls="basic-navbar-nav"
                    data-bs-theme="dark"
                />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                        <NavDropdown
                            title="About us"
                            id="basic-nav-dropdown"
                            style={{ position: "relative" }}
                        >
                            {navMenuItem.about && navMenuItem.about.map((item) => (
                                <NavDropdown.Item
                                    key={item.navTitle}
                                    href={item.navUrl}
                                >
                                    {item.navTitle}
                                </NavDropdown.Item>
                            ))}
                        </NavDropdown>
                        <NavDropdown
                            title="Courses"
                            id="basic-nav-dropdown"
                            style={{ position: "relative" }}
                        >
                            {navMenuItem.course.map((item) => (
                                <NavDropdown.Item
                                    key={item.navTitle}
                                    href={item.navUrl}
                                >
                                    {item.navTitle}
                                </NavDropdown.Item>
                            ))}
                        </NavDropdown>
                        <NavDropdown
                            title="Education"
                            id="basic-nav-dropdown"
                            style={{ position: "relative" }}
                        >
                            {navMenuItem.education.map((item) => (
                                <NavDropdown.Item
                                    key={item.navTitle}
                                    href={item.navUrl}
                                >
                                    {item.navTitle}
                                </NavDropdown.Item>
                            ))}
                        </NavDropdown>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export function NavTopMain(params) {    
    const { navMenuItem } = params;

    showConsole && navMenuItem && console.log(JSON.stringify(navMenuItem));

    return (
        <Navbar expand="lg" className="navBackgroundColor">
            <Container>
                <Navbar.Brand href="/" className="navBrand">
                    ARCH
                </Navbar.Brand>
                <Navbar.Toggle
                    aria-controls="basic-navbar-nav"
                    data-bs-theme="dark"
                />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                        <NavDropdown
                            title="เกี่ยวกับคณะฯ"
                            id="basic-nav-dropdown"
                            style={{ position: "relative" }}
                        >
                            {navMenuItem.about &&
                                navMenuItem.about.map((item) => (
                                    <NavDropdown.Item
                                        key={item.navTitle}
                                        href={item.navUrl}
                                        target="_blank"
                                    >
                                        {item.navTitle}
                                    </NavDropdown.Item>
                                ))}
                        </NavDropdown>
                        <NavDropdown
                            title="หลักสูตรฯ"
                            id="basic-nav-dropdown"
                            style={{ position: "relative" }}
                        >
                            {navMenuItem.course &&
                                navMenuItem.course.map((item) => (
                                    <NavDropdown.Item
                                        key={item.navTitle}
                                        href={item.navUrl}
                                        target="_blank"
                                    >
                                        {item.navTitle}
                                    </NavDropdown.Item>
                                ))}
                        </NavDropdown>
                        <NavDropdown
                            title="นักศึกษา"
                            id="basic-nav-dropdown"
                            style={{ position: "relative" }}
                        >
                            {navMenuItem.student &&
                                navMenuItem.student.map((item) => (
                                    <NavDropdown.Item
                                        key={item.navTitle}
                                        href={item.navUrl}
                                        target="_blank"
                                    >
                                        {item.navTitle}
                                    </NavDropdown.Item>
                                ))}
                        </NavDropdown>
                        <NavDropdown
                            title="เข้าศึกษาต่อ"
                            id="basic-nav-dropdown"
                            style={{ position: "relative" }}
                        >
                            {navMenuItem.education &&
                                navMenuItem.education.map((item) => (
                                    <NavDropdown.Item
                                        key={item.navTitle}
                                        href={item.navUrl}
                                        target="_blank"
                                    >
                                        {item.navTitle}
                                    </NavDropdown.Item>
                                ))}
                        </NavDropdown>
                        <NavDropdown
                            title="ระบบสารสนเทศ"
                            id="basic-nav-dropdown"
                            style={{ position: "relative" }}
                        >
                            {navMenuItem.it &&
                                navMenuItem.it.map((item) => (
                                    <NavDropdown.Item
                                        key={item.navTitle}
                                        href={item.navUrl}
                                        target="_blank"
                                    >
                                        {item.navTitle}
                                    </NavDropdown.Item>
                                ))}
                        </NavDropdown>
                        <NavDropdown
                            title="ดาวน์โหลด"
                            id="basic-nav-dropdown"
                            style={{ position: "relative" }}
                        >
                            {navMenuItem.download &&
                                navMenuItem.download.map((item) => (
                                    <NavDropdown.Item
                                        key={item.navTitle}
                                        href={item.navUrl}
                                        target="_blank"
                                    >
                                        {item.navTitle}
                                    </NavDropdown.Item>
                                ))}
                        </NavDropdown>
                        <Nav.Link href="/researcher" target="_blank">ทำเนียบนักวิจัย</Nav.Link>
                        <Nav.Link href="/deandm" target="_blank">สายตรงคณบดี</Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default function NavTop() {
    const navMenuItem = {
        about: [
            {
                navTitle: "ประวัติ ความเป็นมา",
                navUrl: "/about/",
            },
            {
                navTitle: "ปรัชญา วิสัยทัศน์และพันธกิจ",
                navUrl: "/about/?p=philosophy",
            },
            {
                navTitle: "ผู้บริหารคณะ",
                navUrl: "/person/adminboard",
            },
            {
                navTitle: "คณาจารย์",
                navUrl: "/person/lecturers",
            },
            {
                navTitle: "เจ้าหน้าที่",
                navUrl: "/person/officers",
            },
            {
                navTitle: "ติดต่อเรา",
                navUrl: "/about/contact.php",
            },
        ],
        course: [
            {
                navTitle: "ป.เอก นวัตกรรมการออกแบบเพื่อความยั่งยืน",
                navUrl: "https://aed.mju.ac.th/arch-dis/",
            },
            {
                navTitle: "ป.โท การวางผังเมืองและสภาพแวดล้อม",
                navUrl: "https://aed.mju.ac.th/arch-murp/",
            },
            {
                navTitle: "ป.โท การออกแบบและวางแผนสิ่งแวดล้อม",
                navUrl: "https://aed.mju.ac.th/arch-av/",
            },
            {
                navTitle: "ป.ตรี สถาปัตยกรรมศาสตร์",
                navUrl: "https://edu-arch.mju.ac.th/wtms_newsDetail.aspx?nID=24651&lang=th-TH",
            },
            {
                navTitle: "ป.ตรี ภูมิสถาปัตยกรรมศาสตร์",
                navUrl: "https://aed.mju.ac.th/arch-la/",
            },
            {
                navTitle: "ป.ตรี เทคโนโลยีภูมิทัศน์",
                navUrl: "https://aed.mju.ac.th/arch-lt/",
            },
        ],
        student: [
            {
                navTitle: "Architron 2022",
                navUrl: "https://www.facebook.com/Architron-2022-104944418948825",
            },
            {
                navTitle: "ปฏิทินกิจกรรม",
                navUrl: "https://arch.mju.ac.th/calendar.php?p=stu",
            },
            {
                navTitle: "ระบบบริการการศึกษา",
                navUrl: "http://reg.mju.ac.th/",
            },
            {
                navTitle: "ศูนย์สอบ ICT",
                navUrl: "https://www.facebook.com/ETestingMaejo/",
            },
            {
                navTitle: "ระบบอีเลินนิ่ง",
                navUrl: "http://coursearch.mju.ac.th/",
            },
            {
                navTitle: "MS WINDOWS",
                navUrl: "https://maejonet.mju.ac.th/wtms_webpageDetail.aspx?wID=1271",
            },
            {
                navTitle: "MS OFFICE 365",
                navUrl: "https://www.office.com/",
            },
        ],
        education: [
            {
                navTitle: "ระดับปริญญาตรี",
                navUrl: "http://www.education.mju.ac.th/www/",
            },
            {
                navTitle: "ระดับปริญญาโท",
                navUrl: "http://www.grad.mju.ac.th/",
            },
            {
                navTitle: "ระดับปริญญาเอก",
                navUrl: "http://www.grad.mju.ac.th/",
            },
        ],
        it: [
            {
                navTitle: "ระบบการจองห้องประชุมคณะฯ",
                navUrl: "https://arch.mju.ac.th/calendar/meetingroom",
            },
            {
                navTitle: "ระบบการจองห้องปฏิบัติการคอมฯ",
                navUrl: "https://arch.mju.ac.th/calendar/lab211",
            },
            {
                navTitle: "ระบบการจองใช้เครื่องยิงเลเซอร์",
                navUrl: "https://arch.mju.ac.th/calendar/lasercut",
            },
            {
                navTitle: "ระบบอีเลินนิ่งของคณะฯ",
                navUrl: "https://coursearch.mju.ac.th/",
            },
        ],
        download: [
            {
                navTitle: "เอกสารงานวิจัย",
                navUrl: "https://drive.google.com/drive/folders/1MGAdq_X2FxXa1TH2eKCr_DTL3m0-DP9Q?usp=sharing",
            },
            {
                navTitle: "เอกสารงานบริการวิชาการ",
                navUrl: "https://drive.google.com/drive/folders/1HlVI0vooVs8lAmCqe5gD49UfuWs7535M?usp=sharing",
            },
        ],
    };

    console.table(navMenuItem);

    return (
        <nav
            className="navbar navbar-expand-md navbar-dark"
            style={{ zIndex: 1030, marginBottom: "500px" }}
        >
            <div className="container">
                <a
                    className="navbar-brand"
                    href="/"
                    style={{
                        letterSpacing: "0.2em",
                        fontWeight: "500",
                        fontSize: "1.5rem",
                    }}
                >
                    ARCH
                </a>
                <button
                    className="navbar-toggler d-lg-none"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapsibleNavId"
                    aria-controls="collapsibleNavId"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="collapsibleNavId">
                    <ul className="navbar-nav me-auto mt-2 mt-lg-0">
                        <li className="nav-item dropdown">
                            <a
                                className="nav-link dropdown-toggle"
                                href="foo"
                                id="dropdownId"
                                data-bs-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                            >
                                เกี่ยวกับคณะ
                            </a>
                            <div
                                className="dropdown-menu"
                                aria-labelledby="dropdownId"
                                style={{ zIndex: 9 }}
                            >
                                <a
                                    className="dropdown-item"
                                    href="https://arch.mju.ac.th/about/"
                                    res="noreferer"
                                >
                                    ประวัติ ความเป็นมา
                                </a>
                                <a
                                    className="dropdown-item"
                                    href="https://arch.mju.ac.th/about/?p=philosophy"
                                    res="noreferer"
                                >
                                    ปรัชญา วิสัยทัศน์และพันธกิจ
                                </a>
                                <a
                                    className="dropdown-item"
                                    href="https://arch.mju.ac.th/staff/"
                                    res="noreferer"
                                >
                                    ผู้บริหารคณะ
                                </a>
                                <a
                                    className="dropdown-item"
                                    href="https://arch.mju.ac.th/staff/?p=teach"
                                    res="noreferer"
                                >
                                    คณาจารย์
                                </a>
                                <a
                                    className="dropdown-item"
                                    href="https://arch.mju.ac.th/staff/?p=staff"
                                    res="noreferer"
                                >
                                    เจ้าหน้าที่
                                </a>
                                <a
                                    className="dropdown-item"
                                    href="https://arch.mju.ac.th/about/contact.php"
                                    res="noreferer"
                                >
                                    ติดต่อเรา
                                </a>
                            </div>
                        </li>
                        <li className="nav-item dropdown">
                            <a
                                className="nav-link dropdown-toggle"
                                href="foo"
                                id="dropdownId"
                                data-bs-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                            >
                                หลักสูตร
                            </a>
                            <div
                                className="dropdown-menu"
                                aria-labelledby="dropdownId"
                            >
                                <a
                                    className="dropdown-item"
                                    href="https://aed.mju.ac.th/arch-dis/"
                                    res="noreferer"
                                >
                                    ป.เอก นวัตกรรมการออกแบบเพื่อความยั่งยืน
                                </a>
                                <a
                                    className="dropdown-item"
                                    href="https://aed.mju.ac.th/arch-murp/"
                                    res="noreferer"
                                >
                                    ป.โท การวางผังเมืองและสภาพแวดล้อม
                                </a>
                                <a
                                    className="dropdown-item"
                                    href="https://aed.mju.ac.th/arch-av/"
                                    res="noreferer"
                                >
                                    ป.โท การออกแบบและวางแผนสิ่งแวดล้อม
                                </a>
                                <a
                                    className="dropdown-item"
                                    href="https://edu-arch.mju.ac.th/wtms_newsDetail.aspx?nID=24651&lang=th-TH"
                                    res="noreferer"
                                >
                                    ป.ตรี สถาปัตยกรรมศาสตร์
                                </a>
                                <a
                                    className="dropdown-item"
                                    href="https://aed.mju.ac.th/arch-la/"
                                    res="noreferer"
                                >
                                    ป.ตรี ภูมิสถาปัตยกรรมศาสตร์
                                </a>
                                <a
                                    className="dropdown-item"
                                    href="https://aed.mju.ac.th/arch-lt/"
                                    res="noreferer"
                                >
                                    ป.ตรี เทคโนโลยีภูมิทัศน์
                                </a>
                            </div>
                        </li>
                        <li className="nav-item dropdown">
                            <a
                                className="nav-link dropdown-toggle"
                                href="foo"
                                id="dropdownId"
                                data-bs-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                            >
                                นักศึกษา
                            </a>
                            <div
                                className="dropdown-menu"
                                aria-labelledby="dropdownId"
                            >
                                <a
                                    className="dropdown-item"
                                    href="https://www.facebook.com/Architron-2022-104944418948825"
                                    res="noreferer"
                                >
                                    Architron 2022
                                </a>
                                <a
                                    className="dropdown-item"
                                    href="https://arch.mju.ac.th/calendar.php?p=stu"
                                    target="education"
                                >
                                    ปฏิทินกิจกรรม
                                </a>
                                <a
                                    className="dropdown-item"
                                    href="http://reg.mju.ac.th/"
                                    target="education"
                                >
                                    ระบบบริการการศึกษา
                                </a>
                                <a
                                    className="dropdown-item"
                                    href="https://www.facebook.com/ETestingMaejo/"
                                    res="noreferer"
                                >
                                    ศูนย์สอบ ICT
                                </a>
                                <a
                                    className="dropdown-item"
                                    href="http://coursearch.mju.ac.th/"
                                    target="coursearch"
                                >
                                    ระบบอีเลินนิ่งของคณะฯ
                                </a>
                                <a
                                    className="dropdown-item"
                                    href="https://maejonet.mju.ac.th/wtms_webpageDetail.aspx?wID=1271"
                                    res="noreferer"
                                >
                                    MS Windows
                                </a>
                                <a
                                    className="dropdown-item"
                                    href="https://www.office.com/"
                                    res="noreferer"
                                >
                                    MS Office 365
                                </a>
                            </div>
                        </li>
                        <li className="nav-item dropdown">
                            <a
                                className="nav-link dropdown-toggle"
                                href="foo"
                                id="dropdownId"
                                data-bs-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                            >
                                เข้าศึกษาต่อ
                            </a>
                            <div
                                className="dropdown-menu"
                                aria-labelledby="dropdownId"
                            >
                                <a
                                    className="dropdown-item"
                                    href="http://www.education.mju.ac.th/www/"
                                    target="education"
                                >
                                    ระดับปริญญาตรี
                                </a>
                                <a
                                    className="dropdown-item"
                                    href="http://www.grad.mju.ac.th/"
                                    target="education"
                                >
                                    ระดับบัณฑิตศึกษา
                                </a>
                            </div>
                        </li>
                        <li className="nav-item dropdown">
                            <a
                                className="nav-link dropdown-toggle"
                                href="foo"
                                id="dropdownId"
                                data-bs-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                            >
                                ระบบสารสนเทศ
                            </a>
                            <div
                                className="dropdown-menu"
                                aria-labelledby="dropdownId"
                            >
                                <a
                                    className="dropdown-item"
                                    href="https://arch.mju.ac.th/calendar/meetingroom"
                                    rel="noreferrer"
                                    target="_blank"
                                >
                                    ระบบการจองห้องประชุมคณะฯ
                                </a>
                                <a
                                    className="dropdown-item"
                                    href="https://arch.mju.ac.th/calendar/lab211"
                                    rel="noreferrer"
                                    target="_blank"
                                >
                                    ระบบการจองห้องปฏิบัติการคอมฯ
                                </a>
                                <a
                                    className="dropdown-item"
                                    href="https://arch.mju.ac.th/calendar/lasercut"
                                    rel="noreferrer"
                                    target="_blank"
                                >
                                    ระบบการจองจองใช้เครื่องยิงเลเซอร์
                                </a>
                                <a
                                    className="dropdown-item"
                                    href="https://coursearch.mju.ac.th/"
                                    rel="noreferrer"
                                    target="_blank"
                                >
                                    ระบบอีเลินนิ่งของคณะฯ
                                </a>
                                <a
                                    className="dropdown-item"
                                    href="https://drive.google.com/drive/folders/1MGAdq_X2FxXa1TH2eKCr_DTL3m0-DP9Q?usp=sharing"
                                    rel="noreferrer"
                                    target="_blank"
                                >
                                    เอกสารงานวิจัย
                                </a>
                                <a
                                    className="dropdown-item"
                                    href="https://drive.google.com/drive/folders/1HlVI0vooVs8lAmCqe5gD49UfuWs7535M?usp=sharing"
                                    rel="noreferrer"
                                    target="_blank"
                                >
                                    เอกสารงานบริการวิชาการ
                                </a>
                            </div>
                        </li>
                        <li className="nav-item dropdown">
                            <a
                                className="nav-link dropdown-toggle"
                                href="foo"
                                id="dropdownId"
                                data-bs-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                            >
                                ดาวน์โหลด
                            </a>
                            <div
                                className="dropdown-menu"
                                aria-labelledby="dropdownId"
                            >
                                <a
                                    className="dropdown-item"
                                    href="https://drive.google.com/drive/folders/1MGAdq_X2FxXa1TH2eKCr_DTL3m0-DP9Q?usp=sharing"
                                    rel="noreferrer"
                                    target="_blank"
                                >
                                    ด้านงานวิจัย
                                </a>
                                <a
                                    className="dropdown-item"
                                    href="https://drive.google.com/drive/folders/1HlVI0vooVs8lAmCqe5gD49UfuWs7535M?usp=sharing"
                                    rel="noreferrer"
                                    target="_blank"
                                >
                                    ด้านงานบริการวิชาการ
                                </a>
                            </div>
                        </li>
                        <li className="nav-item">
                            <a
                                className="nav-link"
                                href="https://arch.mju.ac.th/dean_dm.php"
                                rel="noreferrer"
                                target="_blank"
                            >
                                สายตรงคณบดี
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    );
}

/**
 * A function component that renders the navigation bar for personal pages.
 * @param {object} props - The props object.
 * @param {string} props.active - The key of the active navigation link.
 * @param {object} props.navMenuItem - The object containing the navigation menu items.
 * @returns {React.ReactElement} - The navigation bar element.
 * 
 * React functional component ชื่อ NavPerson ที่แสดงแถบการนำทาง (navigation bar) โดยมีโลโก้ของแบรนด์, ปุ่มสลับ (toggle button), และรายการเมนูแบบยุบขยายได้ (collapsible menu items) ซึ่งรายการเมนูจะถูกสร้างขึ้นแบบไดนามิกตามข้อมูลใน prop ชื่อ navMenuItem ที่เป็นอ็อบเจกต์ที่มีรายการเมนูนำทางต่าง ๆ (เช่น กระดานผู้ดูแลระบบ, คอร์ส, อาจารย์, กระดานสำนักงาน, เจ้าหน้าที่) แต่ละรายการเมนูจะแสดงตามเงื่อนไขจากการมีอยู่ของ property ที่สอดคล้องกันในอ็อบเจกต์ navMenuItem นอกจากนี้ prop navActive จะถูกใช้เพื่อตั้งค่าคีย์เริ่มต้นของเมนูนำทาง (navigation menu) ที่ใช้งานอยู่
 * 
 */
export function NavPerson(props) {
    const navActive = props.active;
    const navMenuItem = props.navMenuPerson;
    showConsole && navMenuItem && console.log(JSON.stringify(navMenuItem));
    return (
        <>
            <Navbar expand="lg" className="navBackgroundColor">
                <Container>
                    <Navbar.Brand href="/" className="navBrand">
                        ARCH
                    </Navbar.Brand>
                    <Navbar.Toggle
                        aria-controls="basic-navbar-nav"
                        data-bs-theme="dark"
                    />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="me-auto" defaultActiveKey={navActive}>
                            {navMenuItem.adminboard && (
                                <Nav.Link href={navMenuItem.adminboard.navUrl} eventKey="adminboard">
                                    {navMenuItem.adminboard.navTitle}
                                </Nav.Link>
                            )}
                            {navMenuItem.course && (
                                <NavDropdown
                                    title="อาจารย์ประจำหลักสูตร"
                                    id="basic-nav-dropdown"
                                    style={{ position: "relative" }}
                                >
                                    {navMenuItem.course &&
                                        navMenuItem.course.map((item) => (
                                            <NavDropdown.Item
                                             eventKey={item.navTitle}
                                                key={item.navUrl}
                                                href={item.navUrl}
                                            >
                                                {item.navTitle}
                                            </NavDropdown.Item>
                                        ))}
                                </NavDropdown>
                            )}
                            {navMenuItem.lecturers && (
                                <Nav.Link href={navMenuItem.lecturers.navUrl} eventKey="lecturers">
                                    {navMenuItem.lecturers.navTitle}
                                </Nav.Link>
                            )}
                            {navMenuItem.officeboard && (
                                <Nav.Link href={navMenuItem.officeboard.navUrl} eventKey="officeboard">
                                    {navMenuItem.officeboard.navTitle}
                                </Nav.Link>
                            )}
                            {navMenuItem.officers && (
                                <Nav.Link href={navMenuItem.officers.navUrl} eventKey="officers">
                                    {navMenuItem.officers.navTitle}
                                </Nav.Link>
                            )}
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </>
    );
}

export function NavPerson2(props) {
    const navActive = props.active;
    const navMenuItem = {
        course: [
            {
                navTitle: "นวัตกรรมการออกแบบเพื่อความยั่งยืน (ป.เอก)",
                navUrl: "/person/course_dr",
            },
            {
                navTitle: "การวางผังเมืองและสภาพแวดล้อม (ป.โท)",
                navUrl: "/person/course_mu",
            },
            {
                navTitle: "สถาปัตยกรรมศาสตร์",
                navUrl: "/person/course_ar",
            },
            {
                navTitle: "ภูมิสถาปัตยกรรมศาสตร์",
                navUrl: "/person/course_la",
            },
            {
                navTitle: "เทคโนโลยีภูมิทัศน์",
                navUrl: "/person/course_lt",
            },
            // {
            //     navTitle: "การออกแบบและวางแผนสิ่งแวดล้อม (ป.โท)",
            //     navUrl: "/person/course_av",
            // },
        ],
        office: [
            {
                navTitle: "งานบริหารและธุรการ",
                navUrl: "#1",
            },
            {
                navTitle: "งานคลังและพัสดุ",
                navUrl: "#1",
            },
            {
                navTitle: "งานนโยบาย แผนและประกันคุณภาพ",
                navUrl: "#1",
            },
            {
                navTitle: "งานบริการวิชาการและวิจัย",
                navUrl: "#1",
            },
            {
                navTitle: "งานบริการการศึกษาและกิจการนักศึกษา",
                navUrl: "#1",
            },
        ],
    };
    return (
        <>
            <Navbar expand="lg" className="navBackgroundColor">
                <Container>
                    <Navbar.Brand href="/" className="navBrand">
                        ARCH
                    </Navbar.Brand>
                    <Navbar.Toggle
                        aria-controls="basic-navbar-nav"
                        data-bs-theme="dark"
                    />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="me-auto" defaultActiveKey={navActive}>
                            <Nav.Link href="/person/adminboard">
                                ผู้บริหารคณะ
                            </Nav.Link>
                            <NavDropdown
                                title="อาจารย์ประจำหลักสูตร"
                                id="basic-nav-dropdown"
                                style={{ position: "relative" }}
                            >
                                {navMenuItem.course.map((item) => (
                                    <NavDropdown.Item
                                        key={item.navUrl}
                                        href={item.navUrl}
                                    >
                                        {item.navTitle}
                                    </NavDropdown.Item>
                                ))}
                            </NavDropdown>
                            <Nav.Link href="/person/lecturers">
                                บุคลาการสายวิชาการ
                            </Nav.Link>
                            <Nav.Link href="/person/officeboard">
                                โครงสร้างสำนักงานคณบดี
                            </Nav.Link>
                            {/* <NavDropdown
                title="งานภายใต้สำนักงานคณบดี"
                id="basic-nav-dropdown"
                style={{ position: "relative" }}
              >
                {navMenuItem.office.map((item) => (
                  <NavDropdown.Item key={item.navUrl} href={item.navUrl}>
                    {item.navTitle}
                  </NavDropdown.Item>
                ))}                
              </NavDropdown> */}
                            <Nav.Link href="/person/officers">
                                บุคลาการสายสนับสนุน
                            </Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </>
    );
}

export function NavDeanDm(props) {
    const navActive = props.active;

    return (
        <>
            <Navbar expand="lg" className="navBackgroundColor">
                <Container>
                    <Navbar.Brand href="/" className="navBrand">
                        ARCH
                    </Navbar.Brand>
                    <Navbar.Toggle
                        aria-controls="basic-navbar-nav"
                        data-bs-theme="dark"
                    />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="me-auto" defaultActiveKey={navActive}>
                            {
                                // * active match with href
                            }
                            <Nav.Link href="/deandm">
                                ส่งข้อความสายตรงคณบดี
                            </Nav.Link>
                            <Nav.Link href="/deandm/tracking">
                                ติดตามผลการส่งข้อความ
                            </Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </>
    );
}
